<template>
  <div>

    <OverlayPanel
      :ref="'noteDetails'"
      @click="toggle1"
      appendTo="body"
      :showCloseIcon="true"
      id="noteDetails"
      style="width: 350px;"
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <strong>Note Details</strong>
          </div>
        </div>
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Textarea
              placeholder=""
              :autoResize="true"
              rows="6"
              v-model="noteDetails"
              :disabled="true"
              style="color: blue; width: 100%;"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 150px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button 
              v-for="(obj, index) in getButtons(selectedRow)" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="obj.command()"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <DataTable
      :value="notes"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="noteId"
      :rowHover="true"
      :selection.sync="selectedNotes"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Notes"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
      :style="{ 'width': '100%' }"
      :resizableColumns="true" 
      columnResizeMode="expand"
    >
      <template #header>
        <div class="table-header">Customer Notes</div>
      </template>

      <template #empty> No Notes found! </template>
      <template #loading> Loading Customer Notes. Please wait. </template>

      <Column 
        header="Actions"
        headerStyle="width: 50px; padding: 7.5px 0px;"
        :frozen="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            <Button 
              icon="pi pi-ellipsis-h" 
              class="p-button-rounded p-button-text"
              @click="toggleActions($event, slotProps.data)"
            />
          </div>
        </template>
      </Column>
      <Column
        field="custNoteId"
        header="Id"
        headerStyle="width: 5em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
          <span class="p-column-title"></span>
          {{ slotProps.data.custNoteId }}
          </div>
        </template>
      </Column>
      <Column 
        field="customer.custName" 
        header="Customer Name" 
        :sortable="true"
        headerStyle="width: 13em"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
          <span class="p-column-title"></span>
          {{ slotProps.data.customer ? slotProps.data.customer.custName : '' }}
          </div>
        </template>
      </Column>
      <Column 
        field="quotation.sQuoteNo" 
        header="Quote" 
        :sortable="true"
        headerStyle="width: 10em"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
          <span class="p-column-title"></span>
          {{ slotProps.data.quotation ? slotProps.data.quotation.sQuoteNo : '' }}
          </div>
        </template>
      </Column>
      <Column 
        field="noteHeader" 
        header="Note Title" 
        :sortable="true"
        headerStyle="width: 10em"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
          <span class="p-column-title"></span>
          {{ slotProps.data.noteHeader }}
          </div>
        </template>
      </Column>
      <Column 
        field="noteDetails" 
        header="Details" 
        :sortable="true"
        headerStyle="width: 10em"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
            @mouseover="showNoteDetails(slotProps.data.noteDetails, $event)"
            @mouseout="$refs.noteDetails.hide()"
          >
            <span class="p-column-title"></span>
            {{ slotProps.data.noteDetails ? 
                slotProps.data.noteDetails.length > 18 ? 
                  slotProps.data.noteDetails.substring(0, 18) + '...' 
                  : slotProps.data.noteDetails 
                : slotProps.data.noteDetails }}
          </div>
        </template>
      </Column>
      <Column 
        field="noteTags" 
        header="Tags" 
        :sortable="true"
        headerStyle="width: 10em"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
          <span class="p-column-title"></span>
          {{ slotProps.data.noteTags }}
          </div>
        </template>
      </Column>
      <Column 
        field="createdBy.fullName" 
        header="Created By" 
        :sortable="true"
        headerStyle="width: 10em"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
          <span class="p-column-title"></span>
          {{ slotProps.data.createdBy ? slotProps.data.createdBy.fullName : '' }}
          </div>
        </template>
      </Column>
      <Column
        field="dateCreated"
        header="Date Created"
        :sortable="true"
        headerStyle="width: 10em"
      ></Column>
    </DataTable>

    <Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Are you sure you want to proceed?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text"/>
        <Button label="Yes" icon="pi pi-check" @click="confirmDelete" class="p-button-text" autofocus />
      </template>
    </Dialog>

  </div>
</template>

<script>
export default {
  props: [
    'notes',
    'loading',
    'filters'
  ],
  data: () => ({
    selectedNotes: null,
    selectedRow: null,
    noteDetails: '',
    displayConfirmation: false
  }),
  computed: {
    myPermissions() {
        return this.$store.getters['auth/getUserPermissions']
    },
  },
  methods: {
    async toggle1(event) {
      this.$refs.noteDetails.toggle(event);
    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    showNoteDetails(noteDetails, event) {
      this.noteDetails = noteDetails
      this.toggle1(event)
    },
    toggleActions(event, data) {
      this.selectedRow = data
      this.$refs.opActions.toggle(event);
    },
    delete(data) {
      this.displayConfirmation = true
    },
    confirmDelete() {
      this.displayConfirmation = false
      this.$emit("delete-note", this.selectedRow);
    },
    getButtons(data) { 
      let buttons = [
				{
					label: 'Edit',
					icon: 'pi pi-pencil',
					command: () => {
						this.$emit('edit-note', data)
					}
        }
      ]

    let permission = this.myPermissions.find(a => a.permission.permissionCode === 'DeleteNote');
    if (permission) {
      if (permission.permissionLevel !== 0) {
        buttons.push({
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.delete(data)
            }
        })      
      } 
    }
    return buttons
    
    }
  }
}
</script>

<style>

</style>